import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTS_LOAD,
    ACTION_PROJECTS_LOAD_BY_ID,

    ACTION_PROJECTS_SAVE,

    ACTION_PROJECTS_CREATE,

    ACTION_PROJECTS_VALIDATE,

    IProjectLoadAction,
    IProjectLoadByIdAction,
    IProjectLoadFailureAction,
    IProjectLoadSuccessAction,

    IProjectSaveAction,
    IProjectSaveSuccessAction,
    IProjectSaveFailureAction,

    IProjectCreateAction,
    IProjectCreateSuccessAction,
    IProjectCreateFailureAction,

    IProjectValidateAction,
    IProjectValidateSuccessAction,
    IProjectValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/project";
import { projectsApi } from "../services/projects";


export const
    getProjectsEpic = (action$): Observable<IProjectLoadSuccessAction | IProjectLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTS_LOAD)
            .mergeMap((_action: IProjectLoadAction) => {
                return projectsApi
                    .getProjects()
                    .map(response =>
                        LoadSuccess(response.projects, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProjectsByIdEpic = (action$): Observable<IProjectLoadSuccessAction | IProjectLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTS_LOAD_BY_ID)
            .mergeMap((action: IProjectLoadByIdAction) => {
                return projectsApi
                    .getProjectById(action.id)
                    .map(response =>
                        LoadSuccess(response.project, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectEpic = (action$): Observable<IProjectSaveSuccessAction | IProjectSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTS_SAVE)
            .mergeMap((action: IProjectSaveAction) => {
                return projectsApi
                    .setProject(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.project, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createProjectEpic = (action$): Observable<IProjectCreateSuccessAction | IProjectCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTS_CREATE)
            .mergeMap((_action: IProjectCreateAction) => {
                return projectsApi
                    .createProject()
                    .map(response =>
                        CreateSuccess(response.project, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateProjectEpic = (action$): Observable<IProjectValidateSuccessAction | IProjectValidateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTS_VALIDATE)
            .mergeMap((action: IProjectValidateAction) => {
                return projectsApi
                    .validateProject(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.project, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }